import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Button,
  Card,
  Col,
  Input as AntInput,
  Modal,
  Row,
  Spin,
  Typography,
  Select,
} from 'antd';
import { SemiboldText } from '../../components/common/Text';
import {
  addEmpaneledUser,
  removeNetworkEmpaneledUser,
  fetchEmpaneledUsers,
  fetchUserDetails,
} from '../../services';

const { Option } = Select;
const { Paragraph, Title } = Typography;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;
class NetworkEmpanelUsersScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      centerEmpanelUsers: [],
      userId: null,
      formEditing: false,
      userDetails: null,
      phone: null,
      source: 'manual',
      onboardingReqId: null,
    };
    console.log({ props });

    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    this.fetchEmpaneledUsers();
  };

  fetchEmpaneledUsers = () => {
    this.setState({ loading: true });
    fetchEmpaneledUsers(this.centerId)
      .then((res) => {
        // const empaneledUsers = res;
        const { empaneledUsers } = res;
        if (empaneledUsers) {
          this.setState({
            centerEmpanelUsers: empaneledUsers,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  submit = () => {
    const { userId, source, onboardingReqId } = this.state;
    this.setState({ loading: true });
    addEmpaneledUser({
      centerId: this.centerId,
      empaneledUserId: userId,
      source,
      onboardingReqId: parseInt(onboardingReqId),
    })
      .then(() => {
        this.cancelEditing();
        this.fetchEmpaneledUsers();
      })
      .catch((err) => {
        console.log({ err });
      })
      .finally(() => {
        this.setState({
          loading: false,
          source: 'manual',
          onboardingReqId: null,
        });
      });
  };

  editSpoc = (ele) => {
    this.setState({
      formEditing: true,
      userId: ele.userId,
      userDetails: null,
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      userId: null,
    });
  };

  removeSpoc = (ele) => {
    Modal.confirm({
      title: 'Confirm Removal',
      content: `Are you sure you want to remove ${ele.empaneledUserId} as Empaneled User for this center?`,
      onOk: () => {
        this.setState({ formSaving: true });
        removeNetworkEmpaneledUser(ele.empaneledUserId, this.centerId)
          .then(() => {
            this.fetchEmpaneledUsers();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ formSaving: false });
          });
      },
    });
  };

  onUserIdInputBlur = () => {
    console.log(this.state.userId, this.state.phone, 'userId selection value');
    const { userId, phone } = this.state;
    this.setState({
      loading: true,
    });
    fetchUserDetails(userId, phone)
      .then((response) => {
        if (response && response.userDetails && response.userDetails.length) {
          this.setState({
            userDetails: response.userDetails[0],
            userId: response.userDetails[0].userId,
            phone: response.userDetails[0].userPhone,
          });
        }
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    const {
      loading,
      centerEmpanelUsers,
      userId,
      phone,
      source,
      onboardingReqId,
    } = this.state;
    const renderSpoc = (ele, idx) => {
      return (
        <Col key={idx} span={24} xs={24} md={12}>
          <Card>
            <EduRowComponent>
              <Row type="flex" align="middle" justify="space-between">
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    User Id
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>
                    {ele.empaneledUserId}
                  </Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    Name
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>{ele.userName}</Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    Email
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>{ele.userEmail}</Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    Phone
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>{ele.userPhone}</Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    Sponsor
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>{ele.sponsorName}</Paragraph>
                </Col>
              </Row>
            </EduRowComponent>
            <Row gutter={[24, 16]} style={{ marginTop: '10px' }}>
              <Col xs={24} md={12}>
                <Button
                  block
                  type="danger"
                  onClick={() => this.removeSpoc(ele)}
                >
                  Remove
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      );
    };
    const renderSpocForm = () => {
      return (
        <Card>
          <BodyContainer>
            <Row gutter={24} style={{ width: '34pc' }}>
              <Col xs={24} md={24}>
                <LabelText>User Id</LabelText>
                <AntInput
                  value={userId}
                  placeholder="User Id"
                  onBlur={this.onUserIdInputBlur}
                  onChange={(e) => {
                    this.setState({
                      userId: e.target.value,
                    });
                  }}
                />
              </Col>
              <Col xs={24} md={24}>
                <LabelText>phone</LabelText>
                <AntInput
                  value={phone}
                  placeholder="Phone"
                  onBlur={this.onUserIdInputBlur}
                  onChange={(e) => {
                    this.setState({
                      phone: e.target.value,
                    });
                  }}
                />
              </Col>
              <Col xs={24} md={24}>
                <LabelText>Source</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={source}
                  defaultValue="manual"
                  onChange={(e) => this.setState({ source: e })}
                >
                  <Option value="manual">Manual Request</Option>
                  <Option value="vip">VIP</Option>
                  <Option value="pluton">Pluton</Option>
                </Select>
              </Col>
              {source === 'pluton' ? (
                <Col xs={24} md={24}>
                  <LabelText>Onboarding Request Id</LabelText>
                  <AntInput
                    value={onboardingReqId}
                    placeholder="onboarding request id"
                    onChange={(e) => {
                      this.setState({
                        onboardingReqId: e.target.value,
                      });
                    }}
                  />
                </Col>
              ) : (
                <></>
              )}
            </Row>
            <br></br>

            {this.state.userDetails ? (
              <div>
                <h4>User Details</h4>
                <Row
                  xs={24}
                  md={24}
                  type="flex"
                  align="middle"
                  justify="space-between"
                  gutter={24}
                >
                  <Col xs={12} md={12}>
                    <LabelText>User Name : </LabelText>
                  </Col>
                  <Col>
                    <span>{this.state.userDetails.userName}</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12}>
                    <LabelText>Sponsor : </LabelText>
                  </Col>
                  <Col>
                    <span>{this.state.userDetails.sponsorName}</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12}>
                    <LabelText>Phone : </LabelText>
                  </Col>
                  <Col>
                    <span>{this.state.userDetails.userPhone}</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12}>
                    <LabelText>Email :</LabelText>
                  </Col>
                  <Col>
                    <span>{this.state.userDetails.userEmail}</span>
                  </Col>
                </Row>
              </div>
            ) : (
              <></>
            )}

            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Button
                  type="primary"
                  block
                  style={{ marginRight: 10 }}
                  onClick={this.submit}
                >
                  Add
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button block onClick={this.cancelEditing}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </BodyContainer>
        </Card>
      );
    };
    return (
      <Row type="flex" align="middle" gutter={[16, 16]}>
        <React.Fragment>
          <Col span={24}>
            <Title type={2}>Special empanelment users</Title>
          </Col>
          {loading ? (
            <div>
              <Spin />
            </div>
          ) : (
            <React.Fragment>
              <Col span={24}>{centerEmpanelUsers.map(renderSpoc)}</Col>
              {!this.state.formEditing ? (
                <Col span={24}>
                  <Button
                    style={{ alignSelf: 'center', flex: 0, padding: 4 }}
                    onClick={() => this.editSpoc({})}
                  >
                    Add User
                  </Button>
                </Col>
              ) : (
                renderSpocForm()
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(NetworkEmpanelUsersScreen));
